import React, {RefObject} from 'react'
import NavigationSection from "../../../core/model2/navigation/navigation-section"
import Popover from "../../../core/gd-components/gd-popover/popover-v2"
import PopoverPosition from "../../../core/gd-components/gd-popover/popover-position"
import {PopoverAttachmentType} from "../../../core/gd-components/gd-popover/@const"
import VScroll from "../../../core/gd-components/scrolling/custom-v-scroll/v-scroll"
import {MAIN_MENU_POPOVER_MIN_WIDTH} from "../../navigation/@const"
import UIMainMenuContainer from "../main-menu"

type Props = {
    popoverRef      : RefObject<any>
    refMainScroll   : RefObject<VScroll>
    refMenu         : RefObject<any>
    refScroll       : RefObject<VScroll>
    menu            : UIMainMenuContainer
}

// const debug = "MainMenu_PopoverMenuV2"
const debug = false

export default function MainMenu_PopoverMenuV2(props:Props) {

    // Popovers.closeAll is called without parameter so 'e' may be undefined
    const onClickOutside = (e?:MouseEvent) => {
        const ignoreClick = !!gd.utils.Dom.findNodeByClassName(e?.target, ["ui5-popover-menu"])

        debug && console.log(debug, 'onClickOutside', ignoreClick, e)
        if (!ignoreClick && e) props.menu.onClickOutside(e)
    }

    const navigationSection : NavigationSection = gd.layout.navigation.state.currentSection!

    let menuTheme = gd.ui.uiLeftMenuThemeClass

    const menuClasses       = Classes('ui-menu','top-nav');
    const uiMenuPopoverContainerClass = Classes('ui-menu-popover-container full-height-mpc');

    let offset:string = "0 1"
    // if (!gd.layout.isMenuHiddenForCurrentApp && [LayoutMenuState.MINIMIZED_BY_USER, LayoutMenuState.MINIMIZED_SMALL_SCREEN].includes(gd.layout.menuState)) {
    //     offset = "0 8"
    // }

    let menuWidth = gd.layout.localSettings.menuWidth
    if (menuWidth<MAIN_MENU_POPOVER_MIN_WIDTH) menuWidth = MAIN_MENU_POPOVER_MIN_WIDTH

    let targetClassname = gd.ui.uiLeftTargetClassName
    let popoverMenuClass = gd.ui.uiLeftPopoverClassName

    // popoverClass {'app-no-menu': gd.layout.isMenuHiddenForCurrentApp}

    const popoverPosition = new PopoverPosition({
        attachment      : "top right",
        targetAttachment: "top left",
        offset          : offset,
        attachmentType  : PopoverAttachmentType.VERTICAL,
    })

    return (
        <Popover popoverClass             = {Classes(popoverMenuClass, gd.ui.type, menuTheme)}
                 popoverWith                = {menuWidth}
                 className                  = {uiMenuPopoverContainerClass}
                 position                   = {popoverPosition}
                 constraints                = {[{to: 'window', attachment: 'together'}]}
                 enableArrows               = {false}
                 getTargetFunc              = {() => document.querySelector(targetClassname)}
                 onContainerReference       = {props.popoverRef}
                 outsideClickIgnoreClass    = "toggle-pin"
                 onClickOutside             = {onClickOutside}>
            <div className                  = {menuClasses}>
                <VScroll ref={props.refMainScroll} mutationObserverEnabled={true}>
                    <div className="spacer"/>
                    {navigationSection.menuComponent &&
                        <navigationSection.menuComponent key            = {navigationSection.id}
                                                         ref            = {props.refMenu}
                                                         refScroll      = {props.refScroll}
                                                         noAnimation    = {props.menu.state.noAnimation}
                                                         section        = {navigationSection}/>}
                </VScroll>
            </div>
        </Popover>
    )
}
